import { Flex, Image, Text, VStack } from '@chakra-ui/react'

export const AuthenticationLeftImage = () => {
  return (
    <Flex
      position="relative"
      flex={0.7}
      alignItems="center"
      justifyContent="center"
      backgroundColor="white"
      pt={['100px', '100px', 0]}
      pb={['48px', '48px', 0]}
    >
      <Image
        alt="gigbase"
        position="absolute"
        top="5"
        left="5"
        mb="10"
        display="block"
        src="/images/brand_logo.svg"
      />
      <VStack>
        <Image
          alt=""
          mb="10"
          display="block"
          src="/images/working_re_w93t.svg"
        />
        <Text alignItems="center" fontWeight="bold" fontSize="3xl">
          その人材、ギグベースで。
        </Text>
      </VStack>
    </Flex>
  )
}
